import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import classNames from 'classnames';
import { Icon, ChipOutlined, AnchorLink } from 'platfi-ui-components';

import withModalActions from 'HOC/withModalActions';
import { bemModifier } from 'utils/BEMHelper';

import styles from './ShareableReportLockSection.scss';

const ShareableReportLockSection = ({ subtitle, smallSubtitleWidth, openModal }) => {
  const stylesName = classNames(
    ...bemModifier('m-shareable-report-lock-section__subtitle', {
      'small-width': smallSubtitleWidth,
    }),
  );

  return (
    <div styleName="m-shareable-report-lock-section">
      <div styleName="m-shareable-report-lock-section__title">Pro Feature</div>
      <div styleName={stylesName}>{subtitle}</div>
      <div styleName="m-shareable-report-lock-section__lock-container">
        <ChipOutlined
          small
          grey
          square
          label="PRO"
          styleName="m-shareable-report-lock-section__chip"
        />
        <Icon
          icon="lock"
          className="a-svg-xlarge"
          styleName="m-shareable-report-lock-section__lock-icon"
        />
      </div>
      <AnchorLink primary onClick={() => openModal('subscriptionLimit', { upsellModal: true })}>
        Find Out More
      </AnchorLink>
    </div>
  );
};

ShareableReportLockSection.propTypes = {
  subtitle: PropTypes.string,
  smallSubtitleWidth: PropTypes.bool,
  openModal: PropTypes.func.isRequired,
};

export default withModalActions(
  CSSModules(ShareableReportLockSection, styles, { allowMultiple: true }),
);
